// AuthProvider.tsx
import React from 'react';
import { Navigate } from 'react-router';
import { authContext } from 'src/hooks/useAuthProvider';

const AuthContext = React.createContext(authContext);

const AuthProviderADFS: React.FC = ({ children }) => {
  const loginSSO = () => authContext.login();
  // const logoutSSO = () => authContext.logOut();
  const logoutSSO = () => {
    localStorage.removeItem("authorizationData");
    window.location.replace("/")
    authContext.logOut();
  
  };
  return (
    <AuthContext.Provider value={{ loginSSO, logoutSSO }}>
      {children}
    </AuthContext.Provider>
  );
};

export { AuthProviderADFS, AuthContext };
